export default __webpack_public_path__ + "static/media/services3.c2b9870d.png";